import { IProviderRoutes } from "../interfaces/provider";
import Provider from "./new/provider";
import { Constructor } from "../../global/constructor";
import { IServerData } from "../interfaces/serverInterfaces";
import { HTTPMethod } from "./new/httpMethod";
import { RouteHelper } from "../helpers/routeHelper";
import { Route } from "../enums/route";
import PublicProfile from "../models/publicProfile/publicProfile";

interface IPublicProfileProviderRoutes {
  create: string;
  publish: string;
  unpublish: string;
  getApplication: Route;
}

export default class PublicProfileProvider<
  T extends PublicProfile = PublicProfile
  > extends Provider<T> {
  routes: any;

  constructor(
    protected modelType: Constructor<T>,
    public modelRoot: string,
    public collectionRoot: string
  ) {
    super(modelType, modelRoot, collectionRoot);
    let newRoutes: IPublicProfileProviderRoutes = {
      create: RouteHelper.path({ route: Route.publicProfiles }),
      publish: RouteHelper.path({ route: Route.publishPublicProfile }),
      unpublish: RouteHelper.path({ route: Route.unpublishPublicProfile }),
      getApplication: Route.getApplication
    };
    Object.assign(this.routes, newRoutes);
  }

  publish(publicProfileId: number): Promise<IServerData<any>> {
    return new Promise<IServerData>((resolve, reject) => {
      const json = {
        id: publicProfileId
      };

      this.serverAction({
        endpoint: this.routes.publish,
        method: HTTPMethod.POST,
        json: json
      }).then(resolve);
    });
  }

  unpublish(publicProfileId: number): Promise<IServerData<any>> {
    return new Promise<IServerData>((resolve, reject) => {
      const json = {
        id: publicProfileId
      };

      this.serverAction({
        endpoint: this.routes.unpublish,
        method: HTTPMethod.POST,
        json: json
      }).then(resolve);
    });
  }

  create({
    organizationId,
    folderIdTree,
    publicProfile
  }: {
    organizationId: string;
    folderIdTree: string;
    publicProfile: object;
  }): Promise<IServerData<any>> {
    const json = {
      organization_id: organizationId,
      folder_id_tree: folderIdTree,
      public_profile: publicProfile
    };
    return new Promise<IServerData>((resolve, reject) => {
      this.serverAction({
        endpoint: this.routes.create,
        method: HTTPMethod.POST,
        json: json
      }).then(resolve);
    });
  }

  getApplication({ publicProfile, form_application_id }: { publicProfile: PublicProfile, form_application_id: string; }): Promise<IServerData<any>> {
    const json = { form_application_id: form_application_id };
    return new Promise<IServerData>((resolve, reject) => {
      this.serverAction({
        endpoint: RouteHelper.path({ route: this.routes.getApplication, modelOrId: publicProfile }),
        method: HTTPMethod.GET,
        json: json
      }).then(resolve);
    });
  }
}
